import { call, put, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";
import { api_post, PROYECT } from "services/api";
// Login
const INIT_SESSION_LOGIN = "INIT_SESSION_LOGIN";
const SET_INFO_LOGIN = "SET_TOKEN_LOGIN";
const ERROR_INIT_SESSION_LOGIN = "ERROR_INIT_SESSION_LOGIN";
const CLOSE_SESSION_LOGIN = "CLOSE_SESSION_LOGIN";
const CLEAR_ERROR_LOGIN = "CLEAR_ERROR_LOGIN";

// fields
const SET_USERNAME_LOGIN = "SET_USERNAME_LOGIN";
const SET_PASSWORD_LOGIN = "SET_PASSWORD_LOGIN";
const CLEAR_FIELDS_LOGIN = "CLEAR_FIELDS_LOGIN";

const INITIAL_STATE = {
  // fields
  username: "",
  password: "",
  // call
  error: false,
  isLoading: false,
  errorMessage: "",
  token: null,
  user: null,
  rules: [],
  // sort
};

const asd = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case INIT_SESSION_LOGIN:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        token: null,
        user: null,
        rules: [],
      };
    case SET_INFO_LOGIN:
      return {
        ...state,
        isLoading: false,
        username: "",
        password: "",
        token: payload.token,
        user: payload.user,
        rules: payload.rules,
      };
    case ERROR_INIT_SESSION_LOGIN:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case CLOSE_SESSION_LOGIN:
      return {
        ...INITIAL_STATE,
      };
    case SET_USERNAME_LOGIN:
      return {
        ...state,
        username: payload,
      };
    case SET_PASSWORD_LOGIN:
      return {
        ...state,
        password: payload,
      };
    case CLEAR_FIELDS_LOGIN:
      return {
        ...state,
        username: "",
        password: "",
      };
    case CLEAR_ERROR_LOGIN:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };

    default:
      return state;
  }
};

function initSession(body) {
  return {
    type: INIT_SESSION_LOGIN,
    body,
  };
}
function closeSession() {
  return {
    type: CLOSE_SESSION_LOGIN,
  };
}

function setUsername(username) {
  return {
    type: SET_USERNAME_LOGIN,
    payload: username,
  };
}
function setPassword(password) {
  return {
    type: SET_PASSWORD_LOGIN,
    payload: password,
  };
}

function clearError() {
  return {
    type: CLEAR_ERROR_LOGIN,
  };
}

function* login(action) {
  const { body } = action;

  const url = `${process.env.REACT_APP_URL}${PROYECT}/auth/login`;
  try {
    const response = yield call(api_post, url, body);

    yield put({
      type: SET_INFO_LOGIN,
      payload: {
        token: response.token,
        user: response.name,
        rules: response.rules,
      },
    });
    localStorage.setItem("crm-user", response.token);

    yield put(push("/admin/dashboard"));
  } catch (message) {
    yield put({
      type: ERROR_INIT_SESSION_LOGIN,
      payload: {
        message,
      },
    });
  }
}
function* logout(action) {
  yield put(push("/auth/login"));
  localStorage.removeItem("crm-user");
}

function* loginSaga() {
  yield takeLatest(INIT_SESSION_LOGIN, login);
  yield takeLatest(CLOSE_SESSION_LOGIN, logout);
}

export {
  // reducer
  asd,
  // actions
  initSession,
  closeSession,
  setUsername,
  setPassword,
  clearError,
  //sagas
  loginSaga,
};
